import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DatePicker from "react-datepicker";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { NumericFormat } from "react-number-format";

const getLocale = () => require(`date-fns/locale/es/index.js`);

const HolidaysForm = (props) => {
  const { t } = useTranslation();
  const [initDate, setInitDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const {
    onSubmit,
    cancelAction,
    users,
    userSelected,
    onSelectUser,
    initValues,
  } = props;
  let defaultValue = { value: "", label: "" };
  const [employers, setEmployers] = useState(0);

  useEffect(() => {
    if (initValues.initDate) {
      setInitDate(initValues.initDate);
    }
    if (initValues.endDate) {
      setEndDate(initValues.endDate);
    }
    if (initValues.employers) {
      setEmployers(initValues.employers);
    }
  }, [initValues]);

  const finalUsers = [];
  if (users) {
    for (const user of users) {
      finalUsers.push({
        value: user.uuid,
        label: t(user.email),
      });
    }
  }

  const submitForm = () => {
    if (initDate && endDate && employers && employers > 0) {
      onSubmit(employers, initDate, endDate);
    } else {
      showDialog(
        t("forms.turnHistory.message.turns.title"),
        t("forms.turnHistory.message.turns.errorEmployer"),
        "error",
        false,
        undefined,
        false
      );
    }
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.turnHistory.editTurnForm`)}</h3>
        </div>
      </div>
      <div className="row justify-content-center ">
        <div className="col-12 col-md-11">
          <div className="row">
            <div className="col-12 mt-2 d-flex">
              <label className="control-label mandatory">
                {t("forms.turnHistory.labels.userTurn")}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <Select
                id="user"
                name="user"
                value={userSelected || defaultValue}
                onChange={(value) => {
                  onSelectUser(value);
                }}
                options={finalUsers}
                classNamePrefix="dark"
                placeholder=""
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-2 d-flex">
              <label className="control-label mandatory">
                {t("forms.turnHistory.labels.employers")}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <NumericFormat
                id="employer"
                name="employer"
                maxLength={3}
                className={`inputForm inputText form-control`}
                value={employers}
                onChange={async (event) => {
                  setEmployers(event.target.value);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-2 d-flex">
              <label className="control-label mandatory">
                {t("forms.turnHistory.table.head.initDate")}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <DatePicker
                id="dateTurn"
                name="dateTurn"
                className={`inputFormDate form-control`}
                selected={initDate}
                locale={getLocale()}
                dateFormat={"dd/MM/yyyy HH:mm"}
                showTimeSelect
                onChange={(date) => setInitDate(date)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-2 d-flex">
              <label className="control-label mandatory">
                {t("forms.turnHistory.table.head.endDate")}
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <DatePicker
                id="dateTurn"
                name="dateTurn"
                className={`inputFormDate form-control`}
                selected={endDate}
                locale={getLocale()}
                dateFormat={"dd/MM/yyyy HH:mm"}
                showTimeSelect
                onChange={(date) => setEndDate(date)}
              />
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-10 col-sm-11 text-center mt-5 mb-5">
              <button
                type="button"
                onClick={() => cancelAction()}
                className="btn btn-lg btn-secondary me-2"
              >
                {t(`forms.turnHistory.buttons.cancel`)}
              </button>
              <button
                type="button"
                onClick={() => submitForm()}
                className="btn btn-lg btn-primary"
              >
                {t(`forms.turnHistory.buttons.save`)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

HolidaysForm.propTypes = {
  holidays: PropTypes.array,
  onSubmit: PropTypes.func,
  addTurn: PropTypes.func,
  cancelAction: PropTypes.func,
};

export default HolidaysForm;
